/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var app      = require('mag-app'),
    config   = require('../config'),
    loader   = require('spa-preloader'),
    $HELP    = document.getElementById('helpPanel'),
    $title   = document.getElementById('title'),
    $idLabel = document.getElementById('userTitle'),
    $id      = document.getElementById('userId'),
    $helpTtl = document.getElementById('helpTitle'),
    steps    = [
        document.getElementById('hs1'),
        document.getElementById('hs2'),
        document.getElementById('hs3')
    ];

// $title.innerText = _('Videos to play');
steps[0].innerText = gettext('Install the Magic Cast extension in Chrome, Firefox, Opera, Firefox for Android');
steps[1].innerText = gettext('Specify the device ID in the extension settings');
steps[2].innerText = gettext('The application icon turns blue as soon as a video is detected on the page. When you click on it, the video is sent to your device.'); // eslint-disable-line
$idLabel.innerText = gettext('Device ID:');
$id.innerText = config.user.id || 'n/a';
$helpTtl.innerText = gettext('Start viewing — send the link');

module.exports = {
    showHelp: function () {
        app.list.hide();
        $HELP.classList.add('visible');
        $title.innerText = 'Magic Cast';
        app.list.blur();
        console.log('before hide');
        app.footer.hide();
        console.log('after hide');
    },
    showContent: function () {
        app.list.show();
        app.list.focus();
        $HELP.classList.remove('visible');
        $title.innerText = gettext('Videos to play');
        app.footer.show();
    },
    updateUID: function () {
        $id.innerText = config.user.id || 'n/a';
    },
    preloadImages: function ( callback ) {
        loader.add(
            ['step1.png', 'step2.png', 'step3.png'].map(function (value) {
                return './img/' + app.metrics.height + '/' + value;
            })
        );

        callback && loader.once('done', callback);
    }
};
